var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        stroke: #bcbccb;\r\n        stroke-width: 1.5px;\r\n      }\r\n\r\n      .cls-2, .cls-4 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n      }\r\n\r\n      .cls-3 {\r\n        stroke: none;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9621",
    "data-name": "Group 9621",
    transform: "translate(-1515 -16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1745",
    "data-name": "Ellipse 1745",
    className: "cls-1",
    transform: "translate(1515 16)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 15,
    cy: 15,
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 15,
    cy: 15,
    r: 14.25
  })), /*#__PURE__*/React.createElement("path", {
    id: "user-regular",
    className: "cls-2",
    d: "M9.188,8.906c-.841,0-1.245.469-2.625.469s-1.781-.469-2.625-.469A3.939,3.939,0,0,0,0,12.844v.75A1.407,1.407,0,0,0,1.406,15H11.719a1.407,1.407,0,0,0,1.406-1.406v-.75A3.939,3.939,0,0,0,9.188,8.906ZM6.563,8.438A4.219,4.219,0,1,0,2.344,4.219,4.22,4.22,0,0,0,6.563,8.438Z",
    transform: "translate(1523.5 23.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.a48f882561b8f6b803ebb125a7fab3f0.svg";
export { ForwardRef as ReactComponent };